module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner styleGeneral"
  }, [_c('div', {
    staticClass: "form-group row justify-content-start"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.formsSubTitle.gnrl')) + "\n                "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Email document")]), _vm._v(" "), _c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    staticClass: "checkboxDefaultNegotiationAllowed",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchNotifEmail()
    },
    domProps: {
      "checked": _vm.settings.notif_mail_rcv_doc === '1',
      "value": _vm.settings.notif_mail_rcv_doc
    },
    on: {
      "change": _vm.changeSwitchNotifEmail
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.ngttn_as_dflt')))]), _vm._v(" "), _c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    staticClass: "checkboxDefaultNegotiationAllowed",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchDefaultNegotiation()
    },
    domProps: {
      "checked": _vm.settings.defaultNegotiationAllowed === '1',
      "value": _vm.settings.defaultNegotiationAllowed
    },
    on: {
      "change": _vm.changeSwitchDefaultNegotiationAllowed
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.activate_OCR')))]), _vm._v(" "), _c('label', {
    staticClass: "label-switch",
    class: _vm.sliderColorClass
  }, [_c('input', {
    staticClass: "checkboxOcrActivation",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchOcrActivation()
    },
    domProps: {
      "checked": _vm.settings.ocrActivation === '1',
      "value": _vm.settings.ocrActivation
    },
    on: {
      "change": _vm.changeSwitchOcrActivation
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])])]), _vm._v(" "), (_vm.hasReminderRight()) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.hasReminderRight()) ? _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "form-group row justify-content-start styleGeneral"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.formsSubTitle.reminder')) + "\n                "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.default_reminder_acceptation_active')))]), _vm._v(" "), _c('label', {
    staticClass: "label-switch ",
    class: _vm.sliderColorClass
  }, [_c('input', {
    staticClass: "checkboxDefaultReminderAcceptationActive",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchReminderSettings()
    },
    domProps: {
      "checked": _vm.settings.defaultReminderAcceptationActive === '1',
      "value": _vm.settings.defaultReminderAcceptationActive
    },
    on: {
      "change": _vm.changeSwitchDefaultReminderAcceptationActive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.days_before_reminder_acceptation')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.settings.daysBeforeReminderAcceptation))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.daysBeforeReminderAcceptation),
      expression: "settings.daysBeforeReminderAcceptation"
    }],
    staticClass: "range-slider-streammind",
    class: _vm.sliderColorClass,
    attrs: {
      "type": "range",
      "min": "1",
      "max": "30",
      "value": "30",
      "step": "1",
      "disabled": _vm.canSwitchDaysReminderAcceptation()
    },
    domProps: {
      "value": (_vm.settings.daysBeforeReminderAcceptation)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.settings, "daysBeforeReminderAcceptation", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.days_between_reminder_acceptation')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.settings.daysBetweenReminderAcceptation))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.daysBetweenReminderAcceptation),
      expression: "settings.daysBetweenReminderAcceptation"
    }],
    staticClass: "range-slider-streammind",
    class: _vm.sliderColorClass,
    attrs: {
      "type": "range",
      "min": "1",
      "max": "30",
      "value": "30",
      "step": "1",
      "disabled": _vm.canSwitchDaysReminderAcceptation()
    },
    domProps: {
      "value": (_vm.settings.daysBetweenReminderAcceptation)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.settings, "daysBetweenReminderAcceptation", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.max_number_reminder_acceptation')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.settings.maxNumberReminderAcceptation))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.maxNumberReminderAcceptation),
      expression: "settings.maxNumberReminderAcceptation"
    }],
    staticClass: "range-slider-streammind",
    class: _vm.sliderColorClass,
    attrs: {
      "type": "range",
      "min": "0",
      "max": "10",
      "value": "0",
      "step": "1",
      "disabled": _vm.canSwitchDaysReminderAcceptation()
    },
    domProps: {
      "value": (_vm.settings.maxNumberReminderAcceptation)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.settings, "maxNumberReminderAcceptation", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.default_reminder_payment_active')))]), _vm._v(" "), _c('label', {
    staticClass: "label-switch ",
    class: _vm.sliderColorClass
  }, [_c('input', {
    staticClass: "checkboxDefaultReminderPaymentActive",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchReminderSettings()
    },
    domProps: {
      "checked": _vm.settings.defaultReminderPaymentActive === '1',
      "value": _vm.settings.defaultReminderPaymentActive
    },
    on: {
      "change": _vm.changeSwitchDefaultReminderPaymentActive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.days_before_reminder_payment')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.settings.daysBeforeReminderPayment))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.daysBeforeReminderPayment),
      expression: "settings.daysBeforeReminderPayment"
    }],
    staticClass: "range-slider-streammind",
    class: _vm.sliderColorClass,
    attrs: {
      "type": "range",
      "min": "1",
      "max": "30",
      "value": "0",
      "step": "1",
      "disabled": _vm.canSwitchDaysReminderPayment()
    },
    domProps: {
      "value": (_vm.settings.daysBeforeReminderPayment)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.settings, "daysBeforeReminderPayment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.days_between_reminder_payment')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.settings.daysBetweenReminderPayment))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.daysBetweenReminderPayment),
      expression: "settings.daysBetweenReminderPayment"
    }],
    staticClass: "range-slider-streammind",
    class: _vm.sliderColorClass,
    attrs: {
      "type": "range",
      "min": "1",
      "max": "30",
      "value": "30",
      "step": "1",
      "disabled": _vm.canSwitchDaysReminderPayment()
    },
    domProps: {
      "value": (_vm.settings.daysBetweenReminderPayment)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.settings, "daysBetweenReminderPayment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.max_number_reminder_payment')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.settings.maxNumberReminderPayment))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.maxNumberReminderPayment),
      expression: "settings.maxNumberReminderPayment"
    }],
    staticClass: "range-slider-streammind",
    class: _vm.sliderColorClass,
    attrs: {
      "type": "range",
      "min": "0",
      "max": "10",
      "value": "0",
      "step": "1",
      "disabled": _vm.canSwitchDaysReminderPayment()
    },
    domProps: {
      "value": (_vm.settings.maxNumberReminderPayment)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.settings, "maxNumberReminderPayment", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('div', {
    staticClass: "accordion-item accordionForm"
  }, [_c('a', {
    staticClass: "item-content item-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.rotateChevron($event)
      }
    }
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "form-group row justify-content-start styleGeneral"
  }, [_c('div', {
    staticClass: "item-title createInvoiceBand col-sm-auto"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.formsSubTitle.othr')) + "\n                "), _c('i', {
    staticClass: "f7-icons formChevron"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item-content"
  }, [_c('div', {
    staticClass: "form-group d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('settings.allwys_accpt_documents')))]), _vm._v(" "), _c('label', {
    staticClass: "label-switch ",
    class: _vm.sliderColorClass
  }, [_c('input', {
    staticClass: "checkboxAutoAcceptPayment",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canSwitchAutoAcceptDocument()
    },
    domProps: {
      "checked": _vm.settings.accept_documents === '1',
      "value": _vm.settings.accept_documents
    },
    on: {
      "change": _vm.changeSwitchAutoAcceptDocument
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6620ca6e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6620ca6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/SettingsList/DocumentServiceSettings.vue
// module id = 2382
// module chunks = 2